(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sl-flavor-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.sl-flavor-card__input')) return;
    const swatches = input.closest('.product-information')?.querySelector('rubik-swatch')?.shadowRoot;
    const appInput = Array.from(swatches?.querySelectorAll('input[type="radio"]') || [])
      .find((option) => option.value === input.value);
    if (appInput && !appInput.disabled && !appInput.checked) appInput.click();
  });
  } catch(e) { console.error(e); }
})();

})();
